import { render, staticRenderFns } from "./RejectionsHistory.vue?vue&type=template&id=1e3a1072&scoped=true"
import script from "./RejectionsHistory.vue?vue&type=script&lang=js"
export * from "./RejectionsHistory.vue?vue&type=script&lang=js"
import style0 from "./RejectionsHistory.vue?vue&type=style&index=0&id=1e3a1072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3a1072",
  null
  
)

export default component.exports